import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLinkOut = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 17,
	height: 17,
	fill: "none",
	viewBox: "0 0 17 17",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "#111",
		fillRule: "evenodd",
		d: "M15.999 1.996v-1h-5.997v2h2.583L7.289 8.292l1.414 1.415 5.296-5.297V7h2V1.995ZM.002 17V1h8v2h-6v12h12V9h2v8h-16Z",
		clipRule: "evenodd"
	})
});
export default SvgLinkOut;
